import { executeReport, REPORT_TYPES } from '../../../../../../../../logic/utils/reportRequest';

export default async function SqlQuery(sessionDataId) {
  return executeReport(
    REPORT_TYPES.QUALITY_SURVEY,
    { sessionDataId },
  );
}
